import { PeachOverrideVariant } from 'core/components/PeachOverrides/lib/Override'

import apiMocksOptions from './apiMocksOptions'
import overrideOptions from './overrideOptions'

const _peachOverridesOptions = { ...overrideOptions, ...apiMocksOptions }
export const peachOverridesOptions = _peachOverridesOptions as Record<string, PeachOverrideVariant>

export type PeachOverrideId = keyof typeof _peachOverridesOptions
